import type { InferGetStaticPropsType, NextPage } from 'next'
import React from 'react'

import { createGetStaticData, createGetStaticProps } from '@hozana/api/server/static'
import type { TWrappedStaticContext } from '@hozana/redux/types'

import { Container } from 'elements/layout/Container'
import { H } from 'elements/text/H'
import { Link } from 'elements/text/Link'
import { P } from 'elements/text/P'
import { PageTitle } from 'elements/text/PageTitle'

import { Page } from 'general/structure/Page'
import { NAMESPACE } from 'i18n/constants'
import { PAGE } from 'routes/constants'

import { FaqCategory } from 'modules/home/pages/FaqPage/FaqCategory'
import { getAllQuestionsQuery } from 'modules/home/queries'

import { ContactForm } from './ContactForm'

export const getStaticProps = createGetStaticProps(
  PAGE.CONTACT,
  'home:words.contact-us',
  async (ctx: TWrappedStaticContext<TNoMoreProps>) => {
    if (!ctx.locale) {
      return {
        redirect: {
          permanent: false,
          destination: '/nous-contacter',
        },
      }
    }
    const data = await createGetStaticData(() => ({
      questions: {
        query: getAllQuestionsQuery(),
        getStrategy: 'prop',
      },
    }))(ctx)

    if ('props' in data) {
      const {
        props: { questions },
      } = data
      return { props: { frequentQuestions: questions?.filter((question) => question.category === 'frequent') || [] } }
    }
    return data
  },
  { namespaces: [NAMESPACE.HOME] },
)

export type TContactPageProps = InferGetStaticPropsType<typeof getStaticProps>

export const ContactPage: NextPage<TContactPageProps> = ({ frequentQuestions }) => (
  <Page>
    <Container p={{ xs: '5px 1em 100px', sm: '30px 1em 100px' }} maxW="800px">
      <PageTitle align="center" />
      <FaqCategory questions={frequentQuestions} category="frequent" />
      <P m="1em 0">
        <Link color="blue" hoverUnderline to={{ pathname: PAGE.FAQ }} target="_blank">
          trans:home:home.contact.other-frequent-questions
        </Link>
      </P>
      <H fontSize={{ xs: '1.5em', sm: '2em' }} m="25px 0 1em" color="darkBlue">
        trans:home:home.contact.need-contact
      </H>
      <P fontSize={{ xs: '1rem', md: '1em', lg: '1.15rem' }} m="0 0 1em">
        trans:home:home.contact.use-our-contact-form
      </P>
      <ContactForm />
    </Container>
  </Page>
)
